<div>
	<div mat-dialog-title>
		<h5>{{ data.title }}</h5>
	</div>
	<div mat-dialog-content>
		<div class="row">
			<div class="col-12">
				<p class="content" [innerHTML]="data.content"></p>
			</div>
		</div>
	</div>
	<div mat-dialog-actions class="action-btn">
		<button
			mat-button
			(click)="dialogRef.close(); button.action?.()"
			*ngFor="let button of data.buttons"
			[style.color]="button.role == 'cancel' ? '' : button.role == 'danger' ? '#BC4630' : button.color || '#3E92CC'"
		>
			{{ button.title }}
		</button>
	</div>
</div>
